module.exports = __webpack_public_path__ + "bceefed378ae94804c921ecd6eb783ec.png";